import { useState, useEffect } from 'react';
export function useVideoStructuredData(data) {
  // 	M57 Video Detail Header +
  // PersonalizablePrimaryHeader +
  // HeaderMedia +
  // HeaderMedia360
  const [isSingleComponent, setIsSingleComponent] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const inlineScript = document.createElement('script');
      inlineScript.setAttribute('id', 'structured-video-object');
      inlineScript.setAttribute('type', 'application/ld+json');
      if (Object.keys(data).length) {
        inlineScript.innerHTML = `${data}`;
      }
      const videoScripts = Array.from(document.querySelectorAll('#structured-video-object'));
      if (videoScripts.length === 0) {
        document.body.append(inlineScript);
        setIsSingleComponent(true);
      } else {
        setIsSingleComponent(false);
      }
      return () => {
        inlineScript.remove();
      };
    }
  }, [isSingleComponent]);
}